// extracted by mini-css-extract-plugin
export default {"description":"JZ_Xu","inputs-wrapper":"mOJrx","label":"wz0Xu","input":"Ef2Kf","form":"dC7SJ","column":"T09VB","wrapper":"qoZFk","form-control-wrapper":"JVKxD"};